module.exports = "pegasus/assets/blocks/column-17-tech.png";